import { Injectable } from '@angular/core';
import { TrinityService } from 'app/services/trinity/trinity.service';
import { LabelFull } from 'app/types';
import { Client } from 'app/types/client.types';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OnboardingService {
  private readonly endpoint: string = '/client/onboarding';
  constructor(private trinityService: TrinityService) {}

  getLabels(): Observable<LabelFull[]> {
    return this.trinityService.get<LabelFull[]>(`/label`, { authorized: true });
  }

  startOnboarding(clientName: string): Observable<Client> {
    return this.trinityService.post<Client>(this.endpoint + '/start', {
      body: {
        name: clientName,
      },
      authorized: true,
    });
  }

  createServiceAccount(email: string, password: string): Observable<Client> {
    return this.trinityService.post<Client>(
      this.endpoint + '/dedicated_account',
      {
        body: {
          email: email,
          password: password,
        },
        authorized: true,
      },
    );
  }

  postDriveSelectionForOnboarding(driveIds: string[]): Observable<Client> {
    return this.trinityService.post<Client>(
      this.endpoint + '/drive_selection',
      {
        body: {
          drive_ids: driveIds,
        },
        authorized: true,
      },
    );
  }
}
